
import { Form } from 'react-bootstrap';
import { useFormContext, Controller } from 'react-hook-form';


export default function RHFTextField({ name, label, helperText, required, InputProps, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <Form.Label htmlFor={name} className="form-label">{label}{required && <span className="text-danger">*</span>}</Form.Label>
          <Form.Control className={`form-control  ${error?.message && 'is-invalid'}`} id={name} {...field} {...other} {...InputProps} />

          {other?.design}
          <div className="invalid-feedback">{error?.message}</div>



        </>
      )}
    />
  );
}
